<div class="search-div">
  <!-- search form -->
  <form #form="ngForm" (ngSubmit)="submit()" autocomplete="off">
    <mat-tab-group #tabs mat-stretch-tabs dynamicHeight class="mb-4 tab-group-search dense-5 styled">
      <!-- obligor search -->
      <mat-tab label="Obligor" class="top-tab-obligor-cusip">
        <div class="flex-column">
          <mat-hint class="main-text-font text-sm mb-1" [ngClass]="fcObligorNameInput.valid ? '': 'error-red-text'">
            Enter Obligor Name or Keyword(s)
          </mat-hint>
          <mat-form-field appearance="fill" class="mb-3" subscriptSizing="dynamic" >
            <mat-label>Enter Obligor Name</mat-label>
            <input type="text" matInput [formControl]="fcObligorNameInput" placeholder="Enter Obligor Name"
                   maxlength="255" [matAutocomplete]="autoObligor" >
            <mat-autocomplete (optionSelected)="onAutocompleteObligorSelect($event)" #autoObligor="matAutocomplete" class="styled">
              <mat-option *ngFor="let option of filteredObligors | async" [value]="option.obligorName">
                {{option.obligorName}}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>

          <mat-hint class="main-text-font text-sm mb-1" [ngClass]="fcObligorNameInput.errors ? 'error-red-text': ''">
            Choose State
          </mat-hint>
          <mat-form-field appearance="fill" subscriptSizing="dynamic">
            <mat-label>Enter State name</mat-label>
            <input [formControl]="fcStateAbbrInput" matInput placeholder="Enter State Name"
                   [matAutocomplete]="autoState" (change)="validateStateInput()">
            <mat-autocomplete #autoState="matAutocomplete" [displayWith]="displayFn.bind(this)" class="styled">
              <mat-option *ngFor="let option of filteredStates | async" [value]="option.stateName">
                {{option.stateName + ' (' + option.stateAbbr + ')'}}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>
      </mat-tab>
      <!-- CUSIP search -->
      <mat-tab label="CUSIP">
        <div class="flex-column">
          <mat-hint class="main-text-font text-sm mb-1">Enter CUSIP to Identify Obligor(s)
          </mat-hint>
          <mat-form-field appearance="fill">
            <input #cusipInput [formControl]="fcCusipInput" matInput placeholder="Enter CUSIP" required minlength="6"
                   maxlength="9" pattern="[a-zA-Z0-9]{6,9}" [matAutocomplete]="autoCusip" class="search">
            <mat-autocomplete #autoCusip="matAutocomplete" class="styled">
              <mat-option *ngFor="let option of filteredCusips | async" [value]="option.cusip">
                {{option.cusip}}
              </mat-option>
            </mat-autocomplete>
            <mat-error *ngIf="cusipInput.validity.patternMismatch">Please enter 6-9 alphanumeric characters</mat-error>
            <mat-error *ngIf="cusipInput.validity.valueMissing">Enter CUSIP</mat-error>
          </mat-form-field>
        </div>
      </mat-tab>
    </mat-tab-group>
    <div class="mb-3 text-end search-buttons me-3">
      <button mat-stroked-button type="button" class="styled tertiary" (click)="clearForm()">
        Clear All
      </button>
      <button mat-stroked-button type="submit" class="styled primary ms-2 me-1">
        Search
      </button>
    </div>
  </form>
</div>
